import React, { PureComponent } from 'react';
import {
  Card, CardBody, Col, Button, ButtonToolbar,
} from 'reactstrap';
import { withTranslation } from 'react-i18next';
import PropTypes from 'prop-types';
import { hasAccess, hasGroupAccess } from "../../Services/SecurityService";
import { findCidadeByEstado } from "../../Services/CidadeService";
import { addUsers, updateUsers } from "../../Services/UsersService";
import Select from 'react-select';
import { FullWideNotification } from '../../../shared/components/Notification';
import NotificationSystem from 'rc-notification';

let notificationTC = null;

class CrudEdit extends PureComponent {
  static propTypes = {
    t: PropTypes.func.isRequired
  };

  constructor(props) {
    super(props);
    this.state = {
      selectedRoles: '',
      old_password: '',

      estados: [],
      statesList: [],
      selectedStates: [{value:0, label: this.props.t('forms.loading')+"..."}],

      cidades: [],
      citiesList: [],
      selectedCities: [],
      
      user: {},
      data: {
        id: '',
        email: '',
        password: '',
        role: '',
        firstName: '',
        lastName: '',
        phone: '',
        cpf: '',
        cnpj: '',
        address: '',
        cargo: '',
        cidade: {},
        estado: {},
        avatar: '',
        status: 'ATIVO',
        chatON: 'INATIVO',
        createdAt: '',
        updatedAt: '',
        deleted: false,
        userCreate: {}
      }
    };
  }

  handleSubmit(e){
    const data = { ...this.state.data }

    if(this.validateEntries()){

      if(data.status === undefined || data.status === null || data.status === ''){
        data['status'] = 'ATIVO';
      }
      
      if(data.id === undefined || data.id === null || data.id === ''){
        if(data.password === undefined || data.password === null || data.password === ''){
          data['password'] = "minerbook";
        }
        
        data['userCreate'] = this.state.user;
        
        addUsers(data)
        .then(obj => {
          if(obj !== null && obj !== undefined && obj.error === undefined){
            if(obj.erros.length === 0){
              this.props.updateTable({}, this.props.t('forms.dataCreateSuccess'));
              this.clear({});
            }else{
              if(obj.erros !== undefined && obj.erros !== undefined && obj.erros.length > 0){
                for(let i = 0; i < obj.erros.length; i++){
                  this.show('danger', this.props.t('erros.'+obj.erros[i]));
                }
              }
            }
          } else {
            this.show('danger', this.props.t('forms.dataCreateError'));
          }
        });
      }else{
        updateUsers(data)
        .then(obj => {
          if(obj !== null && obj !== undefined && obj.error === undefined){
            if(obj.erros.length === 0){
              this.props.updateTable(obj, this.props.t('forms.dataUpdateSuccess'));
            }else{
              if(obj.erros !== undefined && obj.erros !== undefined && obj.erros.length > 0){
                for(let i = 0; i < obj.erros.length; i++){
                  this.show('danger', this.props.t('erros.'+obj.erros[i]));
                }
              }  
            }
          } else {
            this.show('danger', this.props.t('forms.dataUpdateError'));
          }
        });
      }
    }
  }

  validateEntries(){
    const data = { ...this.state.data }
    let validated = true;

    if(data.firstName === undefined || data.firstName === null || data.firstName === ''){
      this.show('danger', this.props.t('forms.requiredFieldFirstName'));
      validated = false;
    }

    if(data.lastName === undefined || data.lastName === null || data.lastName === ''){
      this.show('danger', this.props.t('forms.requiredFieldLastName'));
      validated = false;
    }
    
    if(data.email === undefined || data.email === null || data.email === ''){
      this.show('danger', this.props.t('forms.requiredFieldEmail'));
      validated = false;
    }
    
    if(data.phone === undefined || data.phone === null || data.phone === ''){
      this.show('danger', this.props.t('forms.requiredFieldPhone'));
      validated = false;
    }

    if( (data.cpf === undefined || data.cpf === null || data.cpf === '') && 
        (data.cnpj === undefined || data.cnpj === null || data.cnpj === '')){
      this.show('danger', this.props.t('forms.requiredFieldCPF_CNPJ'));
      validated = false;
    }
    
    if(data.role === undefined || data.role === null || data.role === '' || data.role.length === 0){
      this.show('danger', this.props.t('forms.requiredFieldRole'));
      validated = false;
    }

    if(data.estado === undefined || data.estado === null || 
      data.estado.id === undefined || data.estado.id === null || data.estado.id === 0){
      this.show('danger', this.props.t('forms.requiredFieldState'));
      validated = false;
    }

    if(data.cidade === undefined || data.cidade === null || 
      data.cidade.id === undefined || data.cidade.id === null || data.cidade.id === 0){
      this.show('danger', this.props.t('forms.requiredFieldCity'));
      validated = false;
    }

    return validated;  
  }

  buildSelectedRoles(role) {
    const { t } = this.props;
    let selectedRoles = '';
    let rolesList= [];
    if(hasGroupAccess("ROOT") || hasGroupAccess("ADMINISTRADORES")){
      rolesList = [
        {value:"_ADMIN_", label:t('forms.ADMIN')},
        {value:"_USER_", label:t('forms.USER')},
        {value:"_CLIENT_", label:t('forms.CLIENT_P')},
        {value:"_CLIENT_ADMIN_", label:t('forms.CLIENT_ADMIN_P')}
      ];
    }else if(hasGroupAccess("PREFEITURAS_ADMINISTRADORES")){
      rolesList = [
        {value:"_CLIENT_ADMIN_", label:t('forms.ADMIN')},
        {value:"_CLIENT_", label:t('forms.CLIENT')}
      ];
    }else{
      rolesList = [
        {value:"_USER_", label:t('forms.USER')}
      ];
    }
    let total = rolesList.length;
    for(let i = 0; i < total; i++){
      if(rolesList[i].value === role){
        selectedRoles = rolesList[i];
        break;
      }
    }
    return selectedRoles;
  }

  loadCidades(estado, cidade){
    findCidadeByEstado(estado.id)
    .then(response => {
      if(response === undefined){
        response = [];
      }
      let options = [];
      let cidades = [];
      let selectedCities = [];
      if(response !== undefined && response.error === undefined){
        cidades = response;
        if(cidades !== undefined && cidades !== null && cidades.length > 0){
          for(let i = 0; i < cidades.length; i++){
            options.push({value:cidades[i].id, label: cidades[i].name});
          }
          this.setState({ 
            cidades,
            citiesList: options,
            selectedCities
          }, () => {
            if(cidade !== null){
              this.setCidade(cidade);
            }
          });
        }
      } else {
        if(response.errors === undefined){
          response = [];
          this.show('danger', this.props.t('forms.errorListData'));
        } else {
          response = [];
          this.show('danger', response.errors[0].defaultMessage);
        }
      }
    });
  }

  setCidade(cidade){
    const data = { ...this.state.data }

    data["cidade"] = '';
    let selectedCities = [];
    if(cidade !== null){
      for(let i = 0; i < this.state.cidades.length; i++){
        if(this.state.cidades[i].id === cidade.id){
          selectedCities.push({value: this.state.cidades[i].id, label: this.state.cidades[i].name});
          data["cidade"] = this.state.cidades[i];
          break;
        }
      }
    }
    this.setState({ data, selectedCities }, () => {});
  }

  setEstado(estado, cidade){
    const data = { ...this.state.data }

    data["estado"] = '';
    data["cidade"] = '';
    let selectedStates = [];
    let citiesList = [];
    let selectedCities = [];
    if(estado !== null){
      for(let e = 0; e < this.state.estados.length; e++){
        if(this.state.estados[e].id === estado.id){
          selectedStates.push({value: this.state.estados[e].id, label: this.state.estados[e].name});
          data["estado"] = this.state.estados[e];
          selectedCities.push({value:0, label: this.props.t('forms.loading')+"..."});
          break;
        }
      }
    }
    this.setState({ data, selectedStates, citiesList, selectedCities }, () => {
      if(selectedStates.length > 0){
        this.loadCidades(estado, cidade);
      }
    });
  }

  loadData(selected, user, estados) {
    let options = [];

    if(estados !== undefined && estados !== null && estados.length > 0 && this.state.estados.length === 0){
      options = [];
      for(let i = 0; i < estados.length; i++){
        options.push({value:estados[i].id, label: estados[i].name});
      }
      this.setState({ 
        statesList: options, 
        estados: estados 
      });
    }

    if(selected !== undefined && selected !== null){
      if(selected.id === 0){
        this.clear(user);
      }else {
        let selectedRoles = this.buildSelectedRoles(selected.role);
        if(!selected.cpf){selected.cpf = '';}
        if(!selected.cnpj){selected.cnpj = '';}

        this.setState({ 
          data: selected, 
          selectedRoles,
          user
        }, () => {
          if(selected.estado !== undefined && selected.estado !== null && selected.estado.id !== null){
            this.setEstado(selected.estado, selected.cidade);
          }
        });
      }
    }
  }

  componentDidMount() {
    const { selected, user, estados } = this.props;
    this.loadData(selected, user, estados);
    NotificationSystem.newInstance({ style: { top: 65 } }, n => notificationTC = n);
  }

  componentDidUpdate(props, state) {
    if(props.selected !== this.props.selected || props.estados !== this.props.estados){
      this.loadData(this.props.selected, this.props.user, this.props.estados);
    }
  }

  componentWillUnmount() {
    notificationTC.destroy();
  }



  updateField(event) {
    const data = { ...this.state.data }
    data[event.target.name] = event.target.value;
    this.setState({ data })
  }

  updateRolesFieldSelect(event, rolesList) {
    const data = { ...this.state.data }
    const { t } = this.props;

    let selectedRoles = '';
    data["role"] = '';
    if(event !== null){
      for(let j = 0; j < event.length; j++){
        for(let i = 0; i < rolesList.length; i++){
          if(rolesList[i].value === event[j].value){
            selectedRoles = event[j];
            data["role"] = event[j].value;
            break;
          }
        }
      }
    }
    this.setState({ data, selectedRoles });
  }

  updateEstadoSelect(event) {
    if(event !== null && event.length > 0){
      for(let j = (event.length-1); j < event.length; j++){
        this.setEstado({id: event[j].value}, null);
      }
    }else{
      this.setEstado(null, null);
    }
  }

  updateCidadeSelect(event) {
    if(event !== null && event.length > 0){
      for(let j = (event.length-1); j < event.length; j++){
        this.setCidade({id: event[j].value});
      }
    }else{
      this.setCidade(null);
    }
  }

  clear(user){
    const data = { ...this.state.data }
    data['id'] = '';
    data['email'] = '';
    data['password'] = '';
    data['role'] = '';
    data['firstName'] = '';
    data['lastName'] = '';
    data['phone'] = '';
    data['cpf'] = '';
    data['cnpj'] = '';
    data['address'] = '';
    data['cargo'] = '';
    data['cidade'] = {};
    data['estado'] = {};
    data['avatar'] = '';
    data['status'] = 'ATIVO';
    data['chatON'] = 'INATIVO';
    data['createdAt'] = '';
    data['updatedAt'] = '';
    data['deleted'] = false;
    this.setState({ 
      data, 
      user,
      selectedRoles: [],
      old_password: [],
      selectedCities: [],
      selectedStates: [],
    }, () => {});
  }

  cancel(event) {
    this.clear({});
    this.props.updateTable({});
  }

  show = (color, message) => {
    return notificationTC.notice({
      content: <FullWideNotification
        color={color}
        message={message}
        />,
      duration: 3,
      closable: true,
      style: { top: 0, left: 0 },
      className: `full ltr-support`,
    });
  };

  render() {
    const { t } = this.props;
    
    let notOK = !hasAccess("MENU_USER_SAVE");

    let isEdit = false;
    if(this.state.data.id !== '' && this.state.data.id > 0){
      isEdit = true;
    }

    let rolesList= [];
    if(hasGroupAccess("ROOT") || hasGroupAccess("ADMINISTRADORES")){
      rolesList = [
        {value:"_ADMIN_", label:t('forms.ADMIN')},
        {value:"_USER_", label:t('forms.USER')},
        {value:"_CLIENT_", label:t('forms.CLIENT_P')},
        {value:"_CLIENT_ADMIN_", label:t('forms.CLIENT_ADMIN_P')}
      ];
    }else if(hasGroupAccess("PREFEITURAS_ADMINISTRADORES")){
      rolesList = [
        {value:"_CLIENT_ADMIN_", label:t('forms.ADMIN')},
        {value:"_CLIENT_", label:t('forms.CLIENT')}
      ];
    }else{
      rolesList = [
        {value:"_USER_", label:t('forms.USER')}
      ];
    }


    let chatOnField = '';
    if(hasGroupAccess("ROOT") || hasGroupAccess("ADMINISTRADORES")){
      chatOnField = <div className="form__form-group">
                      <span className="form__form-group-label">
                        {t('chats.title')}
                      </span>
                      <div className="form__form-group-field">
                        <div className="form__form-group-field">
                          <label className="radio-btn">
                            <input className="radio-btn__radio"
                              name="chatON"
                              type="radio"
                              value={t('forms.ativo')}
                              onChange={e => this.updateField(e)}
                              checked={this.state.data.chatON === 'ATIVO' ? true : false}
                            />
                            <span className="radio-btn__radio-custom"></span>
                            <span className="radio-btn__label">{t('forms.ativo')}</span>
                          </label>
                          <label className="radio-btn">
                            <input className="radio-btn__radio"
                              name="chatON"
                              type="radio"
                              value={t('forms.inativo')}
                              onChange={e => this.updateField(e)}
                              checked={this.state.data.chatON === 'INATIVO' ? true : false}
                            />
                            <span className="radio-btn__radio-custom"></span>
                            <span className="radio-btn__label">{t('forms.inativo')}</span>
                          </label>
                        </div>
                      </div>
                    </div>
    }

    return (
      <Col md={12} lg={12}>
        <Card>
          <CardBody>
            <div className="form__form-group">
              <h3 className="page-subhead subhead">{t('forms.createUpdate')}</h3>
            </div>
            <div className="form">

              <div className="form__half">
                <div className="form__form-group">
                  <span title={t('forms.requiredField')} className="form__form-group-label">
                    {t('forms.firstName')} <span style={{color: "#ff0000"}}>*</span>
                  </span>
                  <div className="form__form-group-field">
                    <input type="hidden" 
                      name="id"
                      value={this.state.data.id} />
                    <input type="text" 
                      name="firstName"
                      value={this.state.data.firstName}
                      onChange={e => this.updateField(e)}
                      required
                    />
                  </div>
                </div>
                <div className="form__form-group">
                  <span title={t('forms.requiredField')} className="form__form-group-label">
                    {t('forms.email')} <span style={{color: "#ff0000"}}>*</span>
                  </span>
                  <div className="form__form-group-field">
                    <input type="text" 
                      name="email"
                      value={this.state.data.email}
                      onChange={e => this.updateField(e)}
                      required
                    />
                  </div>
                </div>
                <div className="form__form-group">
                  <span className="form__form-group-label">
                    {t('forms.cpf')}
                  </span>
                  <div className="form__form-group-field">
                    <input type="text" 
                      name="cpf"
                      value={this.state.data.cpf}
                      onChange={e => this.updateField(e)}
                    />
                  </div>
                </div>
                <div className="form__form-group">
                  <span title={t('forms.requiredField')} className="form__form-group-label">
                    {t('forms.estado')} <span style={{color: "#ff0000"}}>*</span>
                  </span>
                  <div className="form__form-group-field">
                    <Select
                      isMulti = "true"
                      maxMenuHeight="200px"
                      name="estado"
                      value={this.state.selectedStates}
                      onChange={e => this.updateEstadoSelect(e)}
                      options={this.state.statesList}
                      clearable={true}
                      className="react-select"
                      classNamePrefix="react-select"
                      required
                    />
                  </div>
                </div>
                <div className="form__form-group">
                  <span title={t('forms.requiredField')} className="form__form-group-label">
                    {t('forms.address')} <span style={{color: "#ff0000"}}>*</span>
                  </span>
                  <div className="form__form-group-field">
                    <input type="text" 
                      name="address"
                      value={this.state.data.address}
                      onChange={e => this.updateField(e)}
                      required
                    />
                  </div>
                </div>
                <div className="form__form-group">
                  <span className="form__form-group-label">
                    {t('forms.status')}
                  </span>
                  <div className="form__form-group-field">
                    <div className="form__form-group-field">
                      <label className="radio-btn">
                        <input className="radio-btn__radio"
                          name="status"
                          type="radio"
                          value={t('forms.ativo')}
                          onChange={e => this.updateField(e)}
                          checked={this.state.data.status === 'ATIVO' ? true : false}
                        />
                        <span className="radio-btn__radio-custom"></span>
                        <span className="radio-btn__label">{t('forms.ativo')}</span>
                      </label>
                      <label className="radio-btn">
                        <input className="radio-btn__radio"
                          name="status"
                          type="radio"
                          value={t('forms.inativo')}
                          onChange={e => this.updateField(e)}
                          checked={this.state.data.status === 'INATIVO' ? true : false}
                        />
                        <span className="radio-btn__radio-custom"></span>
                        <span className="radio-btn__label">{t('forms.inativo')}</span>
                      </label>
                    </div>
                  </div>
                </div>
                {chatOnField}
              </div>
              <div className="form__half">
                <div className="form__form-group">
                  <span title={t('forms.requiredField')} className="form__form-group-label">
                    {t('forms.lastName')} <span style={{color: "#ff0000"}}>*</span>
                  </span>
                  <div className="form__form-group-field">
                    <input type="text" 
                      name="lastName"
                      value={this.state.data.lastName}
                      onChange={e => this.updateField(e)}
                      required
                    />
                  </div>
                </div>
                <div className="form__form-group">
                  <span title={t('forms.requiredField')} className="form__form-group-label">
                    {t('forms.phone')} <span style={{color: "#ff0000"}}>*</span>
                  </span>
                  <div className="form__form-group-field">
                    <input type="text" 
                      name="phone"
                      value={this.state.data.phone}
                      onChange={e => this.updateField(e)}
                      placeholder={t('forms.phoneMask')}
                      required
                    />
                  </div>
                </div>
                <div className="form__form-group">
                  <span className="form__form-group-label">{t('forms.cnpj')}</span>
                  <div className="form__form-group-field">
                    <input type="text" 
                      name="cnpj"
                      value={this.state.data.cnpj}
                      onChange={e => this.updateField(e)}
                    />
                  </div>
                </div>
                <div className="form__form-group">
                  <span title={t('forms.requiredField')} className="form__form-group-label">
                    {t('forms.cidade')} <span style={{color: "#ff0000"}}>*</span>
                  </span>
                  <div className="form__form-group-field">
                    <Select
                      isMulti = "true"
                      maxMenuHeight="200px"
                      name="cidade"
                      value={this.state.selectedCities}
                      onChange={e => this.updateCidadeSelect(e)}
                      options={this.state.citiesList}
                      clearable={true}
                      className="react-select"
                      classNamePrefix="react-select"
                      required
                    />
                  </div>
                </div>
                <div className="form__form-group">
                  <span className="form__form-group-label">{t('forms.profissao')}</span>
                  <div className="form__form-group-field">
                    <input type="text" 
                      name="cargo"
                      value={this.state.data.cargo}
                      onChange={e => this.updateField(e)}
                    />
                  </div>
                </div>
                <div className="form__form-group">
                  <span title={t('forms.requiredField')} className="form__form-group-label">
                    {t('forms.perfil')} <span style={{color: "#ff0000"}}>*</span>
                  </span>
                  <div className="form__form-group-field">
                    <Select
                      isMulti = "true"
                      maxMenuHeight="150px"
                      name="role"
                      value={this.state.selectedRoles}
                      onChange={e => this.updateRolesFieldSelect(e, rolesList)}
                      options={rolesList}
                      clearable={true}
                      className="react-select"
                      classNamePrefix="react-select"
                      required
                    />
                  </div>
                </div>
              </div>
              <ButtonToolbar className="form__button-toolbar">
                <Button color="primary" type="submit" disabled={notOK}
                  onClick={e => this.handleSubmit(e)}>
                  {t('forms.save')}
                </Button>
                <Button type="button" onClick={e => this.cancel(e)}>
                  {isEdit ? t('forms.voltar') : t('forms.cancel')}
                </Button>
              </ButtonToolbar>
            </div>
          </CardBody>
        </Card>
      </Col>
    );
  }
}

export default withTranslation('common')(CrudEdit);
